module.exports = __webpack_public_path__ + "static/media/19ESCAP22.5c9625f5.jpg";